module.exports = __webpack_public_path__ + "img/6bc91f1.jpg";